import {inject, Pipe, PipeTransform} from '@angular/core';
import {ParticipantPipe} from './participant.pipe';

@Pipe({standalone: true, name: 'performancePlayerPipe'})
export class PerformancePlayerPipe implements PipeTransform
{
  private participantPipe = inject(ParticipantPipe);

  transform(item: any): string
  {
    if (!item)
      return '';

    if (item.participant)
      return this.participantPipe.transform(item.participant, undefined, undefined, undefined, undefined);
    else if (item.performancePlayers?.length === 1)
      return item.performancePlayers[0].player?.displayName;
    else if (item.performancePlayers?.length > 1)
    {
      let s = '';
      item.performancePlayers.sort((x, y) => x.player.displayName.localeCompare(y.player.displayName));
      for (const pp of item.performancePlayers) // TODO sortieren ?
        s += (s.length > 0 ? ' & ' : '') + pp.player?.displayName;
      return s;
    }
    else return '';
  }
}
